import type {
    ExternalListsClientInterface,
    ExternalListsAttributesParams,
    GetExternalListsParams,
    GroupExternalListsContactCountParams,
} from './externalListsClient.types';
import BaseClient, { type ExtendedAxiosRequestConfig } from '../BaseClient';

export default class GroupExternalListsClient extends BaseClient implements ExternalListsClientInterface {
    constructor(private teamId: number, private groupId: string) {
        super();
    }

    getExternalLists(params?: GetExternalListsParams, config?: ExtendedAxiosRequestConfig) {
        const url = `/api/v3/teams/${this.teamId}/groups/${this.groupId}/external-contact-lists`;
        return this.makeCoreApiRequest(url, 'get', null, params, config);
    }

    getExternalListsCount(params?: GetExternalListsParams) {
        const url = `/api/v3/teams/${this.teamId}/groups/${this.groupId}/external-contact-lists/count`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    getExternalListsContactCount(params: GroupExternalListsContactCountParams) {
        const url = `/api/v3/teams/${this.teamId}/groups/${this.groupId}/external-contact-lists/contact-counts`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    getExternalListsAttributes(params: ExternalListsAttributesParams) {
        const url = `/api/v3/teams/${this.teamId}/groups/${this.groupId}/external-contact-lists/attributes`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }
}
